import script from "./serverSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./serverSetting.vue?vue&type=script&setup=true&lang=ts"

import "./serverSetting.vue?vue&type=style&index=0&id=2ec6819e&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec6819e"]])

export default __exports__